import React, { useEffect } from "react";
import Image from "components/image";
import Hamburger from "components/hamburger-menu";
import useToggle from "hooks/useToggle";
import HeaderData from "./data";
import HeaderBag from "components/header-bag";
import { useSelector } from "react-redux";
import NextDeliveryDate from "components/next-delivery-date";
import Link from "helpers/link";
import { ReactComponent as User } from "assets/svgs/user.svg";
import { useGlobalContext } from "context/global";
import clsx from "clsx/lite";

const UserStatus = ({ isAuthenticated, translation }) => {
	if (isAuthenticated)
		return <NextDeliveryDate />;

	return (
		<nav aria-label="User menu">
			<Link to="/account/login"
				className="border-brown py-0 px-3 rounded-3xl border flex items-center"
				aria-label={translation.other?.login || "Login"}
			>
				<User className="scale-[0.78] user-icon" />
				<span className="hidden md:block">{translation.other?.login}</span>
			</Link>
		</nav>
	);
};

const HeaderMenu = ({ data, path, children }) => {
	const { authenticated } = useSelector((state) => state.account.profile);
	const { isClient } = useSelector((state) => state.global);
	const { logo } = data;
	const { translation, isSubscriptionPage, isCollection, isIndexCollection } = useGlobalContext();
	const [isOpen, toggle] = useToggle();
	const isManageProductsPage = isClient && path?.includes("manage-products");

	useEffect(() => {
		let body = document.body.classList;
		body.toggle("ReactModal__Body--open", isOpen);
	}, [isOpen]);

	return (
		<>
			<header className="w-full block lg:hidden sticky-header" id="pass-header-mobile">
				<nav className={clsx("flex items-center px-2 lg:px-6",
					isSubscriptionPage && isCollection ? "pt-3" : "py-3")} aria-label="Main site mobile navigation">
					<div className="w-1/3 flex justify-start">
						<Hamburger isOpen={isOpen} toggle={toggle} />
					</div>

					<div className="w-1/3 flex justify-center">
						<Image className="w-[70px]" image={logo} alt={logo.alt} to={logo.url} />
					</div>

					<div className="w-1/3 gap-1 justify-end flex">
						<UserStatus
							isAuthenticated={authenticated}
							translation={translation}
						/>
						{!isManageProductsPage && !(isCollection && !isIndexCollection) && <HeaderBag />}
					</div>
				</nav>
				{children}
			</header>

			<HeaderData
				data={data}
				isOpen={isOpen}
				toggle={toggle}
				path={path}
				className="shadow-nav overflow-y-auto"
			/>
		</>
	);
};

export default HeaderMenu;